import React from 'react'; 
import {
    withStyles,
    Grid,
    ButtonBase,
    Select,
    MenuItem,
    Typography,
    withRouter
} from '../../../material-ui';

import { MatchItem } from '.';
import Apis from '../../../network/Apis';
import DateUtils from '../../../control/dateutils';
import MNoLiving from '../../view/MNoLiving';

class MatchSchedule extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            curIdex: 0,
            schudleData: null,
            data: [],
        };
    }

    componentDidMount() {
        this.getLeagueStage();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getLeagueStage = async () => {
        const { competition_id, type_id } = this.props;
        let result = await Apis.encryptionStage(type_id, competition_id);
        console.log('getLeagueStage', result);
        if (result.code == 200) {
            let schudleData = [];
            if (result.data.length == 1) {
                let sdata = result.data[0];
                for (let i = 0; i < sdata.round_count; i++) {
                    schudleData.push({ id: sdata.id, name_zh: i + 1, idx: i, round: i + 1 });
                }
            } else {
                for (let i = 0; i < result.data.length; i++) {
                    let obj = Object.assign({ idx: i }, result.data[i]);
                    schudleData.push(obj);
                }
            }
            this.setState({ schudleData: schudleData });
            this.getLeagueMatch();
        }
    }

    getLeagueMatch = async () => {
        const { competition_id, type_id } = this.props;
        const { curIdex, schudleData } = this.state;
        if (schudleData && schudleData.length > 0) {
            let stage = schudleData[curIdex];
            if (stage) {
                let result = await Apis.encryptionSeasonMatch(type_id, competition_id, stage.id + '', stage.round);
                console.log('getLeagueMatch', result);
                if (result.code == 200) {
                    this.setState({ data: result.data });
                }
            }
        }
    }

    _handleChange = (value) => {
        console.log('_handleChange', value);
        this.setState({ curIdex: value }, () => {
            this.getLeagueMatch();
        });
    }

    _onClickNext = () => {
        let { curIdex, schudleData } = this.state;
        curIdex++;
        if (schudleData) {
            if (curIdex >= schudleData.length) {
                curIdex = schudleData.length - 1;
            }
        }
        this.setState({ curIdex: curIdex }, () => {
            this.getLeagueMatch();
        })
    }

    _onClickLast = () => {
        let { curIdex } = this.state;
        curIdex--;
        if (curIdex < 0) {
            curIdex = 0;
        }
        this.setState({ curIdex: curIdex }, () => {
            this.getLeagueMatch();
        })
    }

    render() {
        const { classes } = this.props;
        const { data, curIdex, schudleData } = this.state;

        if (!data || data.length == 0) {
            return (
                <Grid container justifyContent='center' alignItems='center' style={{ marginTop: '20vw' }}>
                    <MNoLiving />
                </Grid>
            );
        }

        return (
            <Grid style={{ width: '100%' }}>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F2F2F2' }}></Grid>
                <Grid container direction='row' justifyContent='space-around' style={{ marginTop: 12, marginBottom: 12 }}>
                    <ButtonBase onClick={() => this._onClickLast()} className={classes.button}>上一轮</ButtonBase>
                    <Grid container direction='row' alignItems='center' justifyContent='center' style={{ flex: 1, maxWidth: '30vw' }}>
                        <Select value={curIdex} onChange={(e) => this._handleChange(e.target.value)}>
                            {
                                schudleData && schudleData.map((item, i) => (
                                    <MenuItem key={i} value={item.idx + ''} style={{ fontSize: 12, color: '#0D0D0D' }}>{'' + item.name_zh}</MenuItem>
                                ))
                            }
                        </Select>
                    </Grid>
                    <ButtonBase onClick={() => this._onClickNext()} className={classes.button}>下一轮</ButtonBase>
                </Grid>
                <Grid>
                    {
                        data.map((item, i) => (
                            <Grid key={i} container direction='row' justifyContent='center'>
                                <Grid container direction='row' justifyContent='center' alignItems='center' style={{ height: 30, backgroundColor: '#F2F2F2' }}>
                                    <Typography style={{ color: '#0D0D0D', fontSize: 10 }}>{DateUtils.dateFormatMDHM(item.match_time)}</Typography>
                                </Grid>
                                <Grid>
                                    <MatchItem line={false} data={item}></MatchItem>
                                </Grid>
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    button: {
        fontSize: 12,
        backgroundColor: theme.palette.primary.main,
        color: '#FFF',
        borderRadius: 4,
        width: 75,
        height: 25,
    },
    tableBodyCell1: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#FC182B'
    },
    tableBodyCell: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#0d0d0d'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchSchedule));